import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { Button } from "@mui/material";
import axios from "axios";
import { H5 } from "../../components/textStyles/style";

ChartJS.register(
  CategoryScale,
  LinearScale,
  Filler,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const CompanyPurchasesStat = ({ company }) => {
  const [select, setSelect] = useState("months");
  const [ebooksData, setEbooksData] = useState([]);
  const [trailsData, setTrailsData] = useState([]);
  const [coachingData, setCoachingData] = useState([]);
  const [labels, setLabels] = useState([]);

  useEffect(() => {
    const getData = async () => {
      await axios
        .get(
          `${process.env.REACT_APP_COMPANY_PURCHASES}?select=${select}&company_id=${company}&product=ebooks`
        )
        .then((res) => {
          setEbooksData(res.data.map((el) => el.count));


          setLabels(
            res.data.map((el) =>
              select === "days"
                ? `${el._id.day}/${el._id.month}/${el._id.year}`
                : select === "months"
                  ? `${el._id.month}/${el._id.year}`
                  : el._id.year
            )
          );
        });

      await axios
        .get(
          `${process.env.REACT_APP_COMPANY_PURCHASES}?select=${select}&company_id=${company}&product=trails`
        )
        .then((res) => {
          setTrailsData(res.data.map((el) => el.count));

        });
      axios
        .get(
          `${process.env.REACT_APP_COMPANY_PURCHASES}?select=${select}&company_id=${company}&product=coaching`
        )
        .then((res) => {
          setCoachingData(res.data.map((el) => el.count));

        });
    };
    getData();
  }, [select, company]);

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
      },
    },
  };

  const data = {
    labels,
    datasets: [
      {
        label: "Trails",
        data: trailsData,
        borderColor: "rgb(28, 73, 102)",
        borderWidth: 3,
        backgroundColor: "rgba(28, 73, 102, 0.5)",
      },
      {
        label: "Ebooks",
        data: ebooksData,
        borderColor: "rgb(253, 112, 100)",
        borderWidth: 3,
        backgroundColor: "rgba(253, 112, 100, 0.5)",
      },
      {
        label: "Flash Coaching",

        data: coachingData,
        borderColor: "rgb(128, 179, 87)",
        borderWidth: 3,
        backgroundColor: "rgba(128, 179, 87, 0.5)",
      },
    ],
  };

  return (
    <div>
      <div style={{ marginTop: 15 }}>
        {/* <Button
          style={{ marginRight: 8 }}
          onClick={() => setSelect("days")}
          variant="contained"
          color={select !== "days" ? "inherit" : "primary"}
        >
          Last 7 days
        </Button>
        <Button
          style={{ marginRight: 8 }}
          onClick={() => setSelect("months")}
          variant="contained"
          color={select !== "months" ? "inherit" : "primary"}
        >
          Last 12 months
        </Button>
        <Button
          style={{ marginRight: 8 }}
          onClick={() => setSelect("years")}
          variant="contained"
          color={select !== "years" ? "inherit" : "primary"}
        >
          Last 5 years
  </Button>*/}
        <div>
          <Line options={options} data={data} />
        </div>
      </div>
    </div>
  );
};

export default CompanyPurchasesStat;
